import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'

// Eager-load the home page for fastest initial paint
import HomePage from './pages/HomePage'

// Lazy-load all other pages for code splitting
const BrowsePage = lazy(() => import('./pages/BrowsePage'))
const CelebrityPage = lazy(() => import('./pages/CelebrityPage'))
const MediaPage = lazy(() => import('./pages/MediaPage'))
const LeaderboardPage = lazy(() => import('./pages/LeaderboardPage'))
const SearchPage = lazy(() => import('./pages/SearchPage'))
const GenresPage = lazy(() => import('./pages/GenresPage'))
const GenrePage = lazy(() => import('./pages/GenrePage'))
const DecadesPage = lazy(() => import('./pages/DecadesPage'))
const DecadePage = lazy(() => import('./pages/DecadePage'))
const CategoriesPage = lazy(() => import('./pages/CategoriesPage'))
const CategoryPage = lazy(() => import('./pages/CategoryPage'))
const CuratorsPage = lazy(() => import('./pages/CuratorsPage'))
const AboutPage = lazy(() => import('./pages/AboutPage'))
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'))
const TermsPage = lazy(() => import('./pages/TermsPage'))
const AffiliateDisclosurePage = lazy(() => import('./pages/AffiliateDisclosurePage'))
const ContactPage = lazy(() => import('./pages/ContactPage'))
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'))

function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-[40vh]" aria-label="Loading page">
      <div className="animate-spin h-8 w-8 border-2 border-primary-600 dark:border-primary-400 border-t-transparent rounded-full" role="status" aria-label="Loading" />
    </div>
  )
}

function App() {
  return (
    <Layout>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/browse" element={<BrowsePage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/celebrities/:slug" element={<CelebrityPage />} />
          <Route path="/media/:slug" element={<MediaPage />} />
          <Route path="/genres" element={<GenresPage />} />
          <Route path="/genre/:genre" element={<GenrePage />} />
          <Route path="/decades" element={<DecadesPage />} />
          <Route path="/decade/:decade" element={<DecadePage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/category/:category" element={<CategoryPage />} />
          <Route path="/curators" element={<CuratorsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/affiliate-disclosure" element={<AffiliateDisclosurePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </Layout>
  )
}

export default App
